/**
 * created by yxy on 2021/1/14
 * 资源库列表项组件
 * 注意事项。如果下部有别的内容
 * 需要在外层加上清除浮动
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import File from "./file/File";
import Picture from "./picture/Picture";
import Audio from "./audio/Audio";
import Video from "./video/Video";
export default class ResourcePoolDemo extends Component{

    static defaultProps = {
        title:'请传入标题',
        type:'small',
        createTime:'2020-12-22 16:10:11',
        img:"/storage/DFCBEA29DA0EBDA07E62AAD26C094170/small/quality",
        checked:false,
        fileType:'file',
        singleClick:()=>{
           alert("单击")
        },
        doubleClick:()=>{
            alert("双击")
        }
    };
    static propTypes = {
        title:PropTypes.string.isRequired,//传入dom 结构
        type:PropTypes.string.isRequired,//small  middle, big ,list
        checked:PropTypes.bool,//是否选中
        singleClick:PropTypes.func.isRequired,//单击回调函数
        doubleClick:PropTypes.func,//双击函数,
        createTime:PropTypes.string.isRequired,//创建时间,
        fileType:PropTypes.string.isRequired,//file, img,video,audio
        img:PropTypes.string,//如果为图片的话必须传img
    };
    constructor(props) {
        super(props);
        this.state={

        }
    }
    render() {
        let component=<div/>;
        switch (this.props.fileType) {
            case 'file':
                component=<File title={this.props.title} createTime={this.props.createTime} type={this.props.type} checked={this.props.checked} singleClick={()=>{this.props.singleClick&&this.props.singleClick()}} doubleClick={()=>{this.props.doubleClick&&this.props.doubleClick()}}/>;
                break;
            case 'img':
                component=<Picture title={this.props.title} img={this.props.img} createTime={this.props.createTime} type={this.props.type} checked={this.props.checked} singleClick={()=>{this.props.singleClick&&this.props.singleClick()}} doubleClick={()=>{this.props.doubleClick&&this.props.doubleClick()}}/>;
                break;
            case 'video':
                component=<Video title={this.props.title} img={this.props.img} createTime={this.props.createTime} type={this.props.type} checked={this.props.checked} singleClick={()=>{this.props.singleClick&&this.props.singleClick()}} doubleClick={()=>{this.props.doubleClick&&this.props.doubleClick()}}/>;
                break;
            case 'audio':
                component=<Audio title={this.props.title} createTime={this.props.createTime} type={this.props.type} checked={this.props.checked} singleClick={()=>{this.props.singleClick&&this.props.singleClick()}} doubleClick={()=>{this.props.doubleClick&&this.props.doubleClick()}}/>;
                break;
            case 'other':
                component=<Picture title={this.props.title} img={this.props.img} createTime={this.props.createTime} type={this.props.type} checked={this.props.checked} singleClick={()=>{this.props.singleClick&&this.props.singleClick()}} doubleClick={()=>{this.props.doubleClick&&this.props.doubleClick()}}/>;
                break;
        }
        return(
            <div onContextMenu={(e)=>{this.props.currentOnContextMenu(e)}} >
                {component}

            </div>

        )
    }
}